import { render, staticRenderFns } from "./resend_sms.vue?vue&type=template&id=78b27aa1&"
import script from "./resend_sms.vue?vue&type=script&lang=js&"
export * from "./resend_sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports